import { CrudTableViewConfig, CrudViewColumnType, ListGridOrderType } from '@rappider/rappider-components/utils';

export const DATA_SOURCE_MODAL_GRID_CONFIG: CrudTableViewConfig = {
  pageSize: 10,
  showPagination: true,
  nzFrontPagination: false,
  selectable: true,
  enableMultipleSelection: true,
  searchButtonActive: true,
  searchActive: false,
  defaultSearchField: 'title',
  multipleSearchFields: ['title', 'status', 'createdDate'],
  order: {
    type: ListGridOrderType.Ascending,
    fieldName: 'title'
  },
  columns: [
    {
      title: 'Data Source',
      fieldName: 'title',
      type: CrudViewColumnType.Text
    },
    {
      title: 'Status',
      fieldName: 'status',
      type: CrudViewColumnType.Text
    },
    {
      title: 'Category',
      fieldName: 'category',
      type: CrudViewColumnType.Text
    },
    {
      title: 'Ingestion Status',
      fieldName: 'ingestionStatus',
      type: CrudViewColumnType.Text
    },
    {
      title: 'Date',
      fieldName: 'createdDate',
      type: CrudViewColumnType.DateTime
    }
  ],
  itemActions: [],
  filterDataByFields: []
};
